import React from "react";
import { Card, Row, Col, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";

const EventUrlsCard = ({ urls }) => {
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
  };

  const renderUrlRow = (label, url) => (
    <Row className="mb-2" key={label}>
      <Col xs={4} className="fw-semibold text-muted">{label}:</Col>
      <Col className="d-flex align-items-center gap-2">
        <a className="text-break" href={url} target="_blank" rel="noopener noreferrer">{url}</a>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>Copy</Tooltip>}
        >
          <Button
            variant="light"
            size="sm"
            onClick={() => handleCopy(url)}
          >
            <FontAwesomeIcon icon={faCopy} />
          </Button>
        </OverlayTrigger>
      </Col>
    </Row>
  );

  if (!urls?.gallery && !urls?.magicFinder) return null;

  return (
    <Card className="shadow-sm border-0 mt-3">
      <Card.Body>
        <Card.Title className="mb-3 fw-bold">URLs</Card.Title>
        {urls.gallery && renderUrlRow("Gallery", urls.gallery)}
        {urls.magicFinder && renderUrlRow("Magic Finder", urls.magicFinder)}
      </Card.Body>
    </Card>
  );
};

export default EventUrlsCard;
